import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedSplInstrForm from './MedSplInstrForm';

const EditSplInstrModal = ({ show, onHide, splinstrvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(splinstrvalue && (splinstrvalue.spl_instr_id || splinstrvalue.instruction_id || splinstrvalue.splinstr_id || splinstrvalue.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Special Instruction' : 'Add Special Instruction'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedSplInstrForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    splinstrvalue={splinstrvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditSplInstrModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    splinstrvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditSplInstrModal;
